import { EligibleSuggestionStateModel } from '@stores/eligible-suggestion/eligible-suggestion.state';

export class EligibleSuggestionsSet {
  static readonly type = '[EligibleSuggestions] Set';
  constructor(public newEligibleSuggestionState: EligibleSuggestionStateModel) {}
}

export class EligibleSuggestionClear {
  static readonly type = '[EligibleSuggestions] Clear';
}
